import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Col, Row } from 'react-bootstrap'

import StudentCourseService from '../../../service/studentCourseService'
import { errorNotify } from '../../../components/Utils/Toast'
import useToken from '../../../App/useToken'
import UnitReport from '../../../components/Report/UnitReport/UnitReport'
import CourseReport from '../../../components/Report/CourseReport/CourseReport'
import StudentCourseReport from '../../../components/Report/StudentCourseReport/StudentCourseReport'
import SummaryReport from '../../../components/Report/SummaryReport/SummaryReport'
import './Report.css'

export default function Report() {
  const {
    isAdmin,
    isUnitAdminOrUnitSpcAdmin,
    isUnitSpcAdmin,
    getToken,
    getRole,
    getUser,
    isUnitAdmin,
    isAdminViewer,
  } = useToken()
  const isUserAdminViewer = isAdminViewer()
  const token = getToken()
  const { major_name, course_name } = useParams()
  const [nameDisplay, setNameDisplay] = useState()
  const isUserAdmin = isAdmin()
  const isUserUnitAdminOrUnitSpcAdmin = isUnitAdminOrUnitSpcAdmin()
  const [isLoadingData, setIsLoadingData] = useState(true)
  const [reportDate, setReportDate] = useState()
  const [unitReportDate, setUnitReportDate] = useState([])
  const [summaryReportData, setSummaryReportData] = useState([])
  const [courseReportDate, setCourseReportDate] = useState([])

  const getStudentCourse = async () => {
    const studentCourseService = new StudentCourseService()
    const report =
      await studentCourseService.getStudentCourseReportByCourseName({
        course_name,
        token,
      })
    console.log('report :>> ', report)
    setUnitReportDate(report?.unitCountReport)
    setCourseReportDate(report?.courseCountReport)
    setSummaryReportData(report?.summaryReport)
    return report
  }

  useEffect(async () => {
    let ownerTemp = ''
    const courseNameArray = course_name.split('-')
    setNameDisplay(
      `${courseNameArray[0]} ประจำปี ${courseNameArray[1]} ${ownerTemp}`,
    )
    setIsLoadingData(false)
    getStudentCourse()
  }, [])

  return (
    <div className='main-container'>
      <center className='course-name'>{nameDisplay}</center>
      <span className='water-mark'>
        เอกสารฉบับนี้จัดทำผ่านระบบรับสมัครคัดเลือกข้าราชการเข้ารับการศึกษาหลักสูตรหลักของ ทอ.
      </span>
      <hr />
      {courseReportDate.length != 0 && (
        <Row>
          <Col md={5}>
            <CourseReport courseReportDate={courseReportDate} />
          </Col>
          <Col md={7} className='student-course-report'>
            <StudentCourseReport courseReportDate={courseReportDate} />
          </Col>
        </Row>
      )}
      {unitReportDate.length != 0 && (
        <Row className='unit-report'>
          <UnitReport unitReportDate={unitReportDate} />
        </Row>
      )}
      {summaryReportData.length != 0 && (
        <Row className='unit-report'>
          <SummaryReport summaryReportData={summaryReportData} />
        </Row>
      )}


    </div>
  )
}
